// Coerce an unknown thrown value into a human-readable string.
// apiFetch only throws ApiError or UnauthorizedRedirectError today (both
// extend Error), but TanStack Query types `error` as unknown — a typed
// helper documents that contract and stays correct if a future thrower
// rejects with a non-Error.
export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (typeof e === 'string') return e;
  try {
    // JSON.stringify returns undefined (not a throw) for undefined, functions,
    // and symbols — coerce those to a string so we honor the `: string` return.
    const s = JSON.stringify(e);
    return typeof s === 'string' ? s : safeString(e);
  } catch {
    // Circular references make JSON.stringify throw.
    return safeString(e);
  }
}

// String() itself can throw — e.g. a null-prototype object has no toString, and
// a hostile toString can throw. Never let the error formatter be the thrower.
function safeString(e: unknown): string {
  try {
    return String(e);
  } catch {
    return '[unstringifiable error]';
  }
}
